// ── Mock data for VSJ experience prototype ────────────────────────────────────
// Replace each export's source with the real API when integrating.

export interface MockPlace {
  id: string;
  address: string;
  street: string;
  block: string;
  neighborhood: string;
  city: string;
  lat: number;
  lng: number;
}

export type FactorIcon = 'connected' | 'residential' | 'services' | 'activity';

export interface MockProperty {
  type: 'casa' | 'departamento' | 'terreno';
  surfaceM2: number | null;
}

// ── Places (mock geocoder results, San Juan capital) ──────────────────────────

export const MOCK_PLACES: MockPlace[] = [
  {
    id: 'libertador-1250',
    address: 'Av. Libertador Gral. San Martín 1250',
    street: 'Av. Libertador Gral. San Martín',
    block: 'Cuadra 1200',
    neighborhood: 'Capital',
    city: 'San Juan',
    lat: -31.5375,
    lng: -68.5364,
  },
  {
    id: 'mendoza-820-sur',
    address: 'Mendoza 820 Sur',
    street: 'Mendoza',
    block: 'Cuadra 800',
    neighborhood: 'Capital',
    city: 'San Juan',
    lat: -31.5424,
    lng: -68.5366,
  },
  {
    id: 'laprida-456-este',
    address: 'Laprida 456 Este',
    street: 'Laprida',
    block: 'Cuadra 400',
    neighborhood: 'Capital',
    city: 'San Juan',
    lat: -31.5352,
    lng: -68.5301,
  },
];

// ── Property defaults ─────────────────────────────────────────────────────────

export const MOCK_PROPERTY_DEFAULT: MockProperty = {
  type: 'casa',
  surfaceM2: null,
};

export const PROPERTY_TYPE_LABEL: Record<MockProperty['type'], string> = {
  casa: 'una casa',
  departamento: 'un departamento',
  terreno: 'un terreno',
};
